import React, { useEffect, useState } from "react";
import "../../assets/styles/landing.css";
import {
  Link as NavigateLink,
  useLocation,
  useNavigate,
} from "react-router-dom";
import headerLogo from "../../assets/images/landing/header-logo.svg";
import leftDown from "../../assets/images/landing/truck/truck-left-down.svg";
import rightDown from "../../assets/images/landing/truck/truck-right-down.svg";
import leftUp from "../../assets/images/landing/truck/truck-left-up.svg";
import rightUp from "../../assets/images/landing/truck/truck-right-up.svg";
import down from "../../assets/images/landing/truck/truck-down.svg";
import right from "../../assets/images/landing/truck/truck-right.svg";
import heroArrow from "../../assets/images/landing/hero-arrow.svg";
import heroMob from "../../assets/images/landing/hero/hero-mob-img.svg";
import heroMobTruck from "../../assets/images/landing/hero/hero-mob-truck.svg";
import heroImg from "../../assets/images/landing/hero/hero-img.svg";
import danger from "../../assets/images/downloaddanger.png";
import upload from "../../assets/images/landing/hero/upload.svg";
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";
import Loader from "../../reusable_components/loader";
import { ToastContainer, toast } from "react-toastify";
import {
  GET_PRODUCT_DETAILS_ID,
  GET_PRODUCT_DETAILS_QRCODE,
} from "../../services/Api";
import axios from "axios";

export default function LandingPage() {
  const navigate = useNavigate();
  const [id, setId] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  // const [activeSection, setActiveSection] = useState(null);
  const [showToast, setShowToast] = useState(false);

  // const location = useLocation();
  // const stateValue = new URLSearchParams(location.search).get("state");

  // const handleSetActive = (to) => {
  //   setActiveSection(to);
  //   const searchParams = new URLSearchParams(location.search);
  //   stateValue &&

  //   searchParams.delete('state');
  //   navigate(`?${searchParams.toString()}`);
  // };

  // useEffect(() => {
  //   stateValue && scrollToSection(stateValue)
  // }, [stateValue]);

  // const scrollToSection = (section) => {
  //   setActiveSection(section);

  //   scroll.scrollTo(section, {
  //     spy: true,
  //     smooth: true,
  //     offset: -50,
  //     duration: 500,
  //   });
  // };

  const customToastContainer = {
    width: "100%",
  };

  useEffect(() => {
    let script = document.createElement("script");
    script.id = "scriptId";
    script.src = "/assets/scripts/landing.js";
    document.body.append(script);
    const handlePopState = (event) => {
      if (event.state === null) {
        console.log("Back Button Pressed");
      }
    };
    window.addEventListener("popstate", handlePopState);

    return () => {
      const scriptElement = document.getElementById("scriptId");
      if (scriptElement) {
        document.body.removeChild(scriptElement);
      }
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  const CustomToast = () => (
    <div style={{ display: "flex", backgroundImage: "none", padding: "10px" }}>
      <img src={danger} alt="Error" width="55" height="50" />
      <span style={{ marginLeft: "5px" }}>
        {" "}
        Invalid! It indicates counterfeiting. Please report it immediately.
      </span>
    </div>
  );

  const customToastContainerStyle = {
    width: "360px",
    color: "#000000",
    fontSize: "15px",
    position: "fixed",
    top: "0",
    left: "50%",
    transform: "translateX(-50%)",
  };

  useEffect(() => {
    // Check if the page has been reloaded before
    const hasPageBeenReloaded = localStorage.getItem("hasPageBeenReloaded");
    // If not reloaded before, reload the page and set the flag in localStorage
    if (!hasPageBeenReloaded) {
      localStorage.setItem("hasPageBeenReloaded", "true");
      window.location.reload(false);
    }
    // Cleanup function to reset the flag when the component is unmounted
    return () => {
      localStorage.removeItem("hasPageBeenReloaded");
    };
  }, []);

  const getDetails = async (id) => {
    try {
      let res = await axios.get(`${GET_PRODUCT_DETAILS_ID}/${id}`);
      let data = res?.data;

      if (data) {
        navigate(`/productTracking/${data?.display_id}`, { state: data });
      }
    } catch (error) {
      console.log({ error });
      toast.error(<CustomToast />, { style: customToastContainerStyle });
    }
  };

  const handleSubmit = async (e) => {
    if (id && !selectedImage) {
      const isInveId = id.includes("ASSET");
      if (isInveId) {
        navigate(`/productTracking/${id}`);
      } else {
        setShowToast(true);
        toast.error(<CustomToast />, { style: customToastContainerStyle });
      }
    }

    if (selectedImage) {
      const formData = new FormData();
      formData.append("image", selectedImage);
      try {
        await axios.post(GET_PRODUCT_DETAILS_QRCODE, formData).then((resp) => {
          if (resp) {
            const isInveId = resp?.data?.display_id.includes("ASSET");
            if (isInveId) {
              navigate(`/productTracking/${resp?.data?.display_id}`);
            } else {
              setShowToast(true);
              toast.error(<CustomToast />, {
                style: customToastContainerStyle,
              });
            }
          }
        });
      } catch (err) {
        setShowToast(true);
        console.log({ "error msg": err });
        toast.error(<CustomToast />, {
          style: customToastContainerStyle,
        });
      }
    }
  };

  const selectQR = async (e) => {
    const file = e.target.files[0];
    setSelectedImage(file);
    setId(file?.name);
  };

  const handleIdChange = (e) => {
    setId(e.target.value);
    setSelectedImage(null);
  };

  return (
    <div className="landing">
      <header className="headerSec">
        <div className="container">
          <nav className="headerSec__inner">
            <NavigateLink className="headerSec__logo" to="#">
              <img src={headerLogo} alt="logo" />
            </NavigateLink>

            <NavigateLink className="headerSec__btn" to="/login">
              <span>SIGN IN</span>
            </NavigateLink>
          </nav>
        </div>
      </header>

      <div id="smooth-wrapper">
        <div id="smooth-content" className="position-relative">
          <div className="truckSec downwards desk-only">
            <img className="truckSec__left-down" src={leftDown} alt="truck" />
            <img className="truckSec__right-down" src={rightDown} alt="truck" />
            <img className="truckSec__left-up" src={leftUp} alt="truck" />
            <img className="truckSec__right-up" src={rightUp} alt="truck" />
            <img className="truckSec__down" src={down} alt="truck" />
            <img className="truckSec__up" src={down} alt="truck" />
            <img className="truckSec__right" src={right} alt="truck" />
          </div>

          <section className="heroSec" id="home">
            <div className="container">
              <div className="heroSec__content">
                <h1 className="head1 fade-in">
                  A Cutting-Edge Blockchain As A Service
                </h1>
                <p className="desc fade-in">
                  Holografs provides a transparent and secure platform for
                  verifying product authenticity, tracking provenance, and
                  enabling smart ownership.
                </p>
                <div className="search-product fade-in">
                  <div className="search-product__inner">
                    <div className="search-product__upload prefix upload-click">
                      <div className="btn-fab">
                        <input
                          type="file"
                          accept="image/*"
                          onChange={selectQR}
                        />
                        <img src={upload} alt="upload" />
                      </div>
                    </div>
                    <input
                      type="text"
                      placeholder="Search asset by ID or upload QR.."
                      value={id}
                      onChange={handleIdChange}
                    />
                    <button onClick={handleSubmit}>
                      <span className="hgt">Search</span>
                    </button>
                  </div>
                </div>

                <div className="heroSec__arrow fade-in">
                  <img src={heroArrow} alt="scroll down" />
                </div>
              </div>
            </div>
            <div
              className="desk-only heroSec__img replaceWithSVG fade-in fade-in-delay-0.35"
              data-src={heroImg}
            ></div>
            <div className="mob-only heroSec__img-mob fade-in fade-in-delay-0.35">
              <img className="heroSec__img-mob-layer0" src={heroMob} />
              <img
                className="heroSec__img-mob-layer1 replaceWithSVG"
                src={heroMobTruck}
              />
            </div>
          </section>
        </div>
        {/* <!-- #smooth-content --> */}
      </div>
      {/* <!-- #smooth-wrapper --> */}
      {showToast ? (
        <ToastContainer style={customToastContainer} />
      ) : (
        <ToastContainer />
      )}
    </div>
  );
}
